import React from 'react';

import TooltipWrapper from '../Form/TooltipWrapper';

import './_styles.scss';

export function ChargerLastUpdate({ updateReason, timeToShow }) {
  return timeToShow && (
    <div className="charger-last-update">
      <div className="toolbar-separator" />
      <TooltipWrapper
        hideHighlight
        tip={updateReason || null}
      >
        <div className="charger-last-update-label-wrapper">
          <div className="charger-last-update-label">Last Update:</div>
          <div className="withTooltip">{timeToShow}</div>
        </div>
      </TooltipWrapper>
    </div>
  );
}
